import React from 'react';
import { Box, Chip, Typography } from '@mui/material';

export interface PolicyScopeSummaryProps {
  summary: string;
  chips?: string[];
  showChips?: boolean;
}

const PolicyScopeSummary: React.FC<PolicyScopeSummaryProps> = ({
  summary,
  chips = [],
  showChips = false,
}) => {
  return (
    <Box>
      <Typography variant="body2" color="text.secondary">
        {summary}
      </Typography>
      {showChips && chips.length > 0 && (
        <Box sx={{ display: 'flex', gap: 0.75, flexWrap: 'wrap', mt: 1 }}>
          {chips.map((chip) => (
            <Chip key={chip} size="small" variant="outlined" label={chip} />
          ))}
        </Box>
      )}
    </Box>
  );
};

export default PolicyScopeSummary;
